import {ComponentProps, FC} from 'react';

type IconProps = ComponentProps<'svg'> & {
    size?: number;
};

export const IconMarkAsRead: FC<IconProps> = ({
    size = 24,
    width = size,
    height = size,
    fill = 'var(--color-icon-primary)',
    ...rest
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            {...rest}
        >
            <path
                d="M21.2816 2.99844C21.7376 2.68719 22.3598 2.80414 22.6712 3.26016C22.9825 3.71624 22.8646 4.33839 22.4085 4.64981L22.3079 4.71914C20.5598 5.91287 19.1049 7.48803 18.054 9.32559C17.8994 9.59587 17.6273 9.77836 17.3187 9.81973C17.0101 9.86098 16.7001 9.75648 16.4798 9.53652L14.138 7.19766C13.7475 6.80732 13.7478 6.17426 14.138 5.78359C14.5283 5.39307 15.1614 5.39237 15.5521 5.78262L17.0062 7.23574C18.1247 5.60258 19.5391 4.18828 21.18 3.06777L21.2816 2.99844Z"
                fill={fill}
            />
            <path
                d="M12 3.00347C12 3.55298 11.5545 3.99775 11.005 3.99938C10.0929 4.0021 9.3793 4.01259 8.78516 4.05313C7.99945 4.10673 7.49604 4.20987 7.08691 4.3793C5.86177 4.88677 4.88833 5.86021 4.38086 7.08535C4.21143 7.49447 4.1083 7.99789 4.05469 8.78359C4.00046 9.5784 4 10.5869 4 11.9984C4 13.4099 4.00046 14.4185 4.05469 15.2133C4.1083 15.999 4.21143 16.5024 4.38086 16.9115C4.88833 18.1367 5.86177 19.1101 7.08691 19.6176C7.49604 19.787 7.99945 19.8901 8.78516 19.9437C9.57996 19.998 10.5885 19.9984 12 19.9984C13.4115 19.9984 14.42 19.998 15.2148 19.9437C16.0005 19.8901 16.504 19.787 16.9131 19.6176C18.1382 19.1101 19.1117 18.1367 19.6191 16.9115C19.7886 16.5024 19.8917 15.999 19.9453 15.2133C19.9858 14.6202 19.9963 13.9082 19.999 12.9985C20.0007 12.4463 20.4477 11.9984 21 11.9984C21.5523 11.9984 22.0007 12.4463 21.999 12.9985C21.9961 13.9202 21.9848 14.6987 21.9404 15.349C21.8799 16.2367 21.754 16.9837 21.4668 17.6771C20.7563 19.3923 19.3939 20.7548 17.6787 21.4652C16.9852 21.7525 16.2382 21.8783 15.3506 21.9389C14.4771 21.9984 13.3966 21.9984 12.0242 21.9984H12H11.9758C10.6034 21.9984 9.5229 21.9984 8.64941 21.9389C7.76176 21.8783 7.01476 21.7525 6.32129 21.4652C4.60614 20.7548 3.24366 19.3923 2.5332 17.6771C2.24596 16.9837 2.12013 16.2367 2.05957 15.349C2.00372 14.5301 2.00023 13.5293 2.00001 12.2765C2 12.193 2 12.1084 2 12.0226L2 11.9984L2 11.9743C2 10.6018 2 9.52133 2.05957 8.64785C2.12013 7.7602 2.24596 7.0132 2.5332 6.31973C3.24366 4.60458 4.60614 3.2421 6.32129 2.53164C7.01476 2.2444 7.76176 2.11857 8.64941 2.05801C9.30572 2.01325 10.0789 2.00774 11.005 2.00781C11.5545 2.00786 12 2.45397 12 3.00347Z"
                fill={fill}
            />
        </svg>
    );
};
